import clsx from 'clsx';
import * as React from 'react';
import { observer } from 'mobx-react';
import ReportStore from '../../../ReportStore';
import { DashboardResource } from '../../../ReportStore/Types';
import { NotTranslated } from '@execonline-inc/translations';

interface Props {
  store: ReportStore;
  currentDashboardId: number;
  dashboards: ReadonlyArray<DashboardResource>;
}

const Navigation: React.FC<Props> = ({ store, dashboards, currentDashboardId }) => {
  return (
    <div className="no-wrap flex text-sm font-semibold leading-5 text-gray-800">
      {dashboards.map(({ payload }) => (
        <button
          key={payload.id}
          onClick={() => store.setCurrentDashboardId(payload.id)}
          data-intercom-target={`${payload.name.toLowerCase().replace(/\s+/g, '-')}-report-tab`}
          className={clsx(
            'px-4 pb-3.5',
            currentDashboardId === payload.id && 'border-b-2 border-teal-600 text-teal-600',
          )}
        >
          <NotTranslated text={payload.name} />
        </button>
      ))}
    </div>
  );
};

export default observer(Navigation);
